import React, {useState, useEffect} from 'react';
import {withToastManager} from "react-toast-notifications";
import {withRouter} from "react-router-dom";
import queryString from "query-string";
import LoadingIndicator from "../../../meta/LoadingIndicator";
import {connect} from "react-redux";
import {saveUserActivationData} from "../../../../slices/userSlice";
import {calculateFingerPrint} from "../../../../utils/UserUtils";
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";
import withHeader from "../../../hocs/withHeader";
import withFooter from "../../../hocs/withFooter";


function ActivateAccount(props) {

    const urlParams = queryString.parse(props.location.search);

    if(typeof urlParams.id === "undefined" || typeof urlParams.verification_code === 'undefined') {
        props.history.push("/register");
    }

    const [loadingActivation,setLoadingActivation] = useState(true);
    const [activationRequestFailed,setActivationRequestFailed] = useState(false);

    useEffect(()=>{
        calculateFingerPrint((browserFingerprint)=>{
            let userPayload = {
                userId : urlParams.id,
                verificationCode : urlParams.verification_code,
                browserFingerPrint : browserFingerprint
            };
            AuthenticationService.activateUser(userPayload,
                (success)=>{
                    props.saveUserActivationData(success.data.user_id,success.data.token,success.data.level);
                    setLoadingActivation(false);
                    props.history.push("/surveys");
                },
                (error)=>{
                    setActivationRequestFailed(true);
                });
        });
    },[]);

    function redirectToContact(){
        props.history.push('/contact');
    }

    return (<React.Fragment>
        <section className="confirm-account">
            <div className="container">
                {
                    loadingActivation && !activationRequestFailed && <LoadingIndicator/>
                }
                {
                    activationRequestFailed &&
                    <section className="confirm-account">
                        <div className="container">
                            <h2 className="pt-xlg pb-xl">Error in confirming your account, please try again.</h2>
                            <div className="cta__wrapp pv-xlg">
                                <button
                                    onClick={redirectToContact}
                                    className="cta--normal cta--notransform ">Contact us here</button>
                            </div>
                        </div>
                    </section>
                }
            </div>
        </section>
    </React.Fragment>)
}


const mapDispatchToProps = {saveUserActivationData};

export default connect(null, mapDispatchToProps)(withFooter(withHeader(withRouter(withToastManager(ActivateAccount)))));